import React, {createContext, PropsWithChildren, useContext, useState} from "react";

export interface TaskContextProps {
  userId: string;
  setUserId: (id: string) => void;
  getBoUserId: () => string;
  clearUserId: () => void;
}

const TaskContext = createContext<TaskContextProps>(undefined!);

const TaskProvider = ({children}: PropsWithChildren) => {
  const [userId, setUserIdInternal] = useState("");

  const setUserId = (id: string) => {
    sessionStorage.setItem("userId", id);
    setUserIdInternal(id);
  };

  const getBoUserId = () => {
    const id = sessionStorage.getItem("userId") || userId;
    return String(id);
  };

  const clearUserId = () => {
    sessionStorage.removeItem("userId");
  };

  return (
    <TaskContext.Provider
      value={{
        userId,
        setUserId,
        getBoUserId,
        clearUserId,
      }}
    >
      {children}
    </TaskContext.Provider>
  );
};

const useTask = (): TaskContextProps => {
  const context = useContext(TaskContext);

  if (!context) throw new Error("TaskContext must be used inside user TaskProvider");

  return context;
};

export {TaskContext, TaskProvider, useTask};
